$(document).ready(function() {
  console.log('Script loaded and ready'); // Debugging step 1
  $('.card .ruk-rating-snippet-count').each(function() {
    var text = $(this).text();
    console.log('Original text:', text); // Debugging step 2
    var match = text.match(/\((\d+)\sReviews?\)/); // Matches both "(2 Reviews)" and "(1 Review)"
    if (match) {
      console.log('Match found:', match[1]); // Debugging step 3
      if (match[1] !== "1") {
        $(this).html('(' + match[1] + ')');
        console.log('Updated HTML:', $(this).html()); // Debugging step 4
      }
    } else {
      console.log('No match found'); // Debugging step 5
    }
  });
});